export default __webpack_public_path__ + "static/media/transaction.b9d6c1c2.svg";